import React from 'react';

type DrawerSectionHeaderProps = {
  text: string;
  icon?: React.ReactNode;
  rightElement?: React.ReactNode;
};

export function DrawerSectionHeader({ text, icon, rightElement }: DrawerSectionHeaderProps) {
  return (
    <div className="tw:flex tw:items-center tw:justify-between tw:mb-2">
      <div className="tw:flex tw:items-center tw:gap-2">
        {icon}
        <span className="tw:text-brand-green-0 tw:italic tw:text-sm">{text}</span>
      </div>
      {rightElement ? <div className="tw:ml-4">{rightElement}</div> : null}
    </div>
  );
}

type DrawerFieldProps = {
  label: string;
  value: React.ReactNode;
  whitespacePreLine?: boolean;
  disableIndent?: boolean;
};

export function DrawerField({ label, value, whitespacePreLine, disableIndent }: DrawerFieldProps) {
  return (
    <>
      <div className={`tw:text-zinc-400 tw:text-sm ${disableIndent ? '' : 'tw:ml-5.75'}`}>
        {label}:
      </div>
      <div className={`tw:text-zinc-700 ${whitespacePreLine ? 'tw:whitespace-pre-line' : ''}`}>
        {value || '--'}
      </div>
    </>
  );
}
